<template>
    <div>
        <div
            v-for="(program, index) in programItems"
            v-bind:key="index"
            class="my-2 d-flex align-items-center"
            v-bind:class="getClassObject(program)">
            <button
                class="btn border-0 shadow-none rounded-circle btn-outline-primary d-flex align-items-center"
                v-bind:aria-label="program.display"
                style="padding: 0.375rem"
                v-on:click="$emit('fav-clicked', program)">
                <pc-bs-icon v-bind:name="program.isFavorite ? 'star-fill' : 'star'" />
            </button>
            <a
                v-bind:href="program.url"
                class="text-truncate"
                v-bind:title="program.display"
                v-bind:data-test-program-url="agencyName ? `${agencyName} - ${program.display}` : null">
                {{ program.display }}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            agencyName: { type: String, required: false, default: null },
            programItems: { type: Array, required: true },
            isAllProgramsList: { type: Boolean, required: false, default: false }
        },
        emits: ["fav-clicked"],
        methods: {
            getClassObject(program) {
                return {
                    "prog-not-fav": !program.isFavorite,
                    "bg-primary-100 pc-selected-program":
                        program.programId === this.$app.ProgramInfo.ProgramId && this.isAllProgramsList
                };
            }
        }
    };
</script>

<style lang="scss" scoped>
    .prog-not-fav {
        svg {
            color: transparent;
        }
        &:hover {
            svg {
                color: inherit;
            }
        }
    }
</style>
